import type Fuse from "fuse.js";
import type { Index, Asset, Prefab } from "./model";

export interface Filters {
  kinds: Set<string>;
  categories: Set<string>;
  tags: Set<string>;
}

export interface State {
  index: Index | null;
  view: "assets" | "prefabs";
  selectedAsset: { prefab: string; id: string } | null;
  selectedPrefab: { id: string; version: string | null } | null;
  search: string;
  filters: Filters;
  fuseAssets: Fuse<Asset> | null;
  fusePrefabs: Fuse<Prefab> | null;
}

export const state: State = {
  index: null,
  view: "prefabs",
  selectedAsset: null,
  selectedPrefab: null,
  search: "",
  filters: { kinds: new Set(), categories: new Set(), tags: new Set() },
  fuseAssets: null,
  fusePrefabs: null,
};
